import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import LaunchIcon from '@mui/icons-material/Launch';
import TableCell from '@mui/material/TableCell';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import TableContainer from '@mui/material/TableContainer';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import logo from './logo.svg';
import './App.css';
import React from 'react';       
import { useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
const GrayTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: theme.palette.action.hover,
}));

function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const authorization = urlParams.get('auth'); 
  const site_id = urlParams.get('site_id'); 
  const host = urlParams.get('host'); 
  const [clients, setClients] = useState([])
  const [duplicates, setDuplicates] = useState([])
  const [matchFullName, setMatchFullName] = useState(true)
  const [matchFirstLast, setMatchFirstLast] = useState(false)
  const [matchPhone, setMatchPhone] = useState(false)
  
  const [groups, setGroups] = useState([])
  const [activeGroupId, setActiveGroupId] = useState(null)

  const [matchZip, setMatchZip] = useState(false)
  const [matchCity, setMatchCity] = useState(false)
  const [matchAddress1, setMatchAddress1] = useState(false)
  const [activeDuplicateId, setActiveDuplicatesId] = useState(null) 
  const [activeDuplicates, setActiveDuplicates] = useState([]) 
  const [isLoadingDuplicates, setIsLoadingDuplicates] = useState(false)
  const [isLoadingCorrespondingDuplicates, setIsLoadingCorrespondingDuplicates] = useState(false)
  const [toMerge, setToMerge] = useState([])
  const [mergeError, setMergeError] = useState(null)

  useEffect( () => {
    loadGroups()
  }, [])
 
  useEffect( () => {
    setMergeError(null)
  }, [activeDuplicateId])

  const getNextDuplicateId = (duplicateId) => {
    var seen = false
    for (const dup of duplicates){
      if (seen)
        return dup.id
      if (dup.id == duplicateId)
        seen = true
    }
  }

  const getFilterString = () => {
    var filters = []
    if (matchFullName)
      filters = filters.concat('fullName')
    if (matchZip)
      filters = filters.concat('zip')
    if (matchCity)
      filters = filters.concat('city')
    if (matchFirstLast)
      filters = filters.concat('firstLast')
    if (matchPhone)
      filters = filters.concat('phone')
    if (matchAddress1)
      filters = filters.concat('address_1')
    return filters.join(',')
  }

  const getJoinKey = (info) => {
    var out = ''
    out += info.firstname || ''
    out += info.middlename || ''
    out += info.lastname || ''
    out += info.phone || ''
    out += info.address_1 || ''
    return out
  }
  
  const archiveMerge = (duplicateInfo) => {
    setDuplicates((oldDuplicates) => oldDuplicates.filter((duplicate) => duplicate.id != duplicateInfo.id)) 
    findCorrespondingDuplicates(getNextDuplicateId(duplicateInfo.id))
  }
  
  const merge = (duplicateInfo) => {
    if (activeDuplicates.filter((x) => x.master).length == 0) {
      setMergeError(<><b>Must select a client to be the master client.</b> This is the client that all other accounts will be merged into.</>)
      return
    }
    if (activeDuplicates.filter((x) => x.merge || x.master).length < 2) {
      setMergeError('Must select multiple clients to merge together, or click cancel') 
      return
    }

    const request_json = {
      "duplicates": activeDuplicates.filter((dup) => !dup.master).map((dup) => dup.id)
    }
    
    const master_id = activeDuplicates.filter((dup) => dup.master)[0].id
    setToMerge((oldMerges) => {
      return oldMerges.concat({ ...duplicateInfo, duplicates: activeDuplicates })
    })
    
    setActiveDuplicates([])
    findCorrespondingDuplicates(getNextDuplicateId(duplicateInfo.id))
    setDuplicates((oldDuplicates) => oldDuplicates.filter((duplicate) => duplicate.id != duplicateInfo.id)) 
    
    fetch(host + '/cms/duplicates/' + master_id + '.json?site_id=' + site_id + '&authorization=' + authorization,
      { 
        "method": "PATCH",
        "headers" : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          },
        "body": JSON.stringify(request_json)       
       })
    .then((res) => res.json())
    .then((json) => {
      setToMerge((oldMerges) => {
        return oldMerges.map((row) => {
          if (row.id == duplicateInfo.id) {
            var updated = {...row, ['status']: 'completed'}
            return updated
          }
          else {
            return row
          }
        })
    })
    })
  }

  const formatClientStatus = (clientStatus) => {
    if (clientStatus == 'pending')
      return <Chip label="Sent" color="primary" /> 
    else if (clientStatus == 'pending_expired')
      return <Chip label="Expired" color="warning" /> 
    else if (clientStatus == 'signed')
      return <Chip label="Signed" color="success" /> 
    else if (clientStatus == 'terminated')
      return <Chip label="Terminated" color="error" /> 
    else if (clientStatus == 'rejected')
      return <Chip label="Rejected" color="error" /> 
    else if (clientStatus == 'initial')
      return <Chip label="Not Sent" color="info" /> 
    else 
      return <Chip label={clientStatus} color="info" /> 
  }
  
  const setShouldMerge = (id, shouldMerge) => {
    setActiveDuplicates((oldActiveDuplicates) => oldActiveDuplicates.map((dup) => {
      if (dup.id == id)
        dup.merge = shouldMerge
      return dup
    }))
  }
  
  const setMaster = (id, isMaster) => {
    setActiveDuplicates((oldActiveDuplicates) => oldActiveDuplicates.map((dup) => {
      if (dup.id == id)
        dup.master = isMaster 
      else if (isMaster)
        dup.master = false 
      return dup
    }))
  }

  const filterString = getFilterString()

  const loadGroups = () => {
    if (site_id == null)
      return 
    fetch(host + '/api/groups.json?site_id=' + site_id + '&authorization=' + authorization + '&filters=' + filterString,
      { 
        "method": "GET",
        "headers" : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          }
       })
    .then((res) => res.json())
    .then((json) => {
      setGroups(json)
    })
  }

  const findCorrespondingDuplicates = (client_id) => {
    if (client_id == null)
      return 
    setIsLoadingCorrespondingDuplicates(false)
    fetch(host + '/cms/duplicates/' + client_id + '.json?site_id=' + site_id + '&authorization=' + authorization + '&filters=' + filterString + (activeGroupId ? '&group_id=' + activeGroupId : ''),
      { 
        "method": "GET",
        "headers" : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          }
       })
    .then((res) => res.json())
    .then((json) => {
      setIsLoadingCorrespondingDuplicates(false)
      setActiveDuplicatesId(client_id)
      json.map((item) =>  { item.master = false; item.merge = true })
      json[0].master = true
      setActiveDuplicates(json)
    })
  }
 
  const columns: GridColDef[] = [
    (matchFirstLast || matchFullName) ? { field: 'firstname', headerName: 'First Name' } : null,
    (matchFirstLast || matchFullName) ? { field: 'lastname', headerName: 'Last Name' } : null,
    matchPhone ? { field: 'mobilephone', headerName: 'Phone' } : null, 
    matchZip ? { field: 'zip', headerName: 'Zip' } : null, 
    matchCity ? { field: 'city', headerName: 'City' } : null, 
    matchAddress1 ? { field: 'address_1', headerName: 'Address 1' } : null, 
    {
      field: 'numDuplicates',
      headerName: '# of Duplicates',
      type: 'number',
      valueGetter: (value, row) => `${row.duplicates.filter((dup) => dup.master || dup.merge).length}`,
      width: 120,
    },
    {
      field: 'status',
      headerName: 'Status',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      width: 160,
      renderCell: (params) =>  params.row.status == 'completed' ? <Chip label="Complete" color="success" /> : <Chip label="Pending" color="primary" />  
    },
  ].filter((col) => col);

  const paginationModel = { page: 0, pageSize: 10 };
  
  const formatPhone = (phoneString) => {
    if (!phoneString)
      return ''
    if(phoneString.length == 11)
      return '(' + phoneString.slice(1,4) + ') ' + phoneString.slice(4,7) + '-' + phoneString.slice(7,11)
    return phoneString
  }

  const geTableCelluplicates = () => {
    setIsLoadingDuplicates(true)
    const request_json = {
      "duplicates": { 
        "filters": filterString,
        "group_id": activeGroupId
      }
    }
    fetch(host + '/cms/duplicates.json?site_id=' + site_id  + '&authorization=' + authorization,
      { 
        "method": "POST",
        "headers" : { 
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          },
        "body": JSON.stringify(request_json)       
       })
    .then((res) => res.json())
    .then((json) => {
      setIsLoadingDuplicates(false)
      setActiveDuplicates([])
      setToMerge([])
      setActiveDuplicatesId(null)
      const grouped = (json.next_duplicates)
      setDuplicates(grouped)
    })
  }

  const incompleteMerges = toMerge.filter((row) => row.status != 'completed')
  
  return (
    <div className="App">
      <Box sx={{ display: 'inline-flex', justifyContent: 'center', width: '100%' }}> 
        <Card variant="outlined" sx={{ p: 2, m: 1, width: "500px" }} >
          <Typography gutterBottom variant="h5" component="div">
            Duplicate Settings
          </Typography>
          <Divider />
          
          <Typography sx={{m: 2}} >Specify below the fields to match potential duplicates on.</Typography> 
          <FormControlLabel
            label="Full Name"
            disabled={incompleteMerges.length > 0}
            control={<Checkbox checked={matchFullName} onChange={(e) => setMatchFullName(e.target.checked)} />}
          />
          <FormControlLabel
            label="First + Last"
            disabled={incompleteMerges.length > 0}
            control={<Checkbox checked={matchFirstLast} onChange={(e) => setMatchFirstLast(e.target.checked)} />}
          />
          <FormControlLabel
            label="Phone"
            disabled={incompleteMerges.length > 0}
            control={<Checkbox checked={matchPhone} onChange={(e) => setMatchPhone(e.target.checked)} />}
          />
          <FormControlLabel
            label="Street Address 1"
            disabled={incompleteMerges.length > 0}
            control={<Checkbox checked={matchAddress1} onChange={(e) => setMatchAddress1(e.target.checked)} />}
          />
          <FormControlLabel
            label="City"
            disabled={incompleteMerges.length > 0}
            control={<Checkbox checked={matchCity} onChange={(e) => setMatchCity(e.target.checked)} />}
          />
          <FormControlLabel
            label="Zipcode"
            disabled={incompleteMerges.length > 0}
            control={<Checkbox checked={matchZip} onChange={(e) => setMatchZip(e.target.checked)} />}
          />
          
          <Box sx={{ width: "auto", pl: 5, pr: 5, pt: 3, pb: 3}}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Group to Filter By (Optional)</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={activeGroupId}
                label="Select Group To Filter By (optional)"
                onChange={(e) => setActiveGroupId(e.target.value ? parseInt(e.target.value) : null)}
              >
                <MenuItem value={null}>No Group Filter</MenuItem>
                {groups.map((group) => <MenuItem value={group.id}>{group.name}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ m: 2 }}>
            <Button 
              sx={{ width: "100%" }} 
              color='primary' 
              onClick={() => geTableCelluplicates() }
              disabled={isLoadingDuplicates || incompleteMerges.length > 0}
              loading={isLoadingDuplicates}
              variant={isLoadingDuplicates ? 'contained' : "outlined"}>
                Find Potential Duplicates
              </Button>
          </Box>
          { incompleteMerges.length > 0 &&
            <>
              <Alert icon={<CheckIcon fontSize="inherit" />} severity="info">
                Please wait for the pending merges to complete before starting your next search.
              </Alert>
            </>
          }
        </Card>
        <Card variant="outlined" sx={{ p: 2, m: 1, flexGrow: 1 }} >
          <Typography gutterBottom variant="h5" component="div">
            Pending Account Merges 
          </Typography>
          <Divider />
           <DataGrid
            rows={incompleteMerges}
            columns={columns}
            localeText={{ noRowsLabel: "Confirm some duplicates for merging and afterwards they will appear here." }}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10]}
            checkboxSelection
            sx={{ border: 0, height: "350px" }}
          />
           
        </Card>
        <Card variant="outlined" sx={{ p: 2, m: 1, flexGrow: 1 }} >
          <Typography gutterBottom variant="h5" component="div">
            Completed Account Merges 
          </Typography>
          <Divider />
           <DataGrid
            rows={toMerge.filter((row) => row.status == 'completed')}
            columns={columns}
            localeText={{ noRowsLabel: "Confirm some duplicates for merging and afterwards they will appear here." }}
            initialState={{ pagination: { paginationModel } }}
            pageSizeOptions={[5, 10]}
            checkboxSelection
            sx={{ border: 0, height: "350px" }}
          />
           
        </Card>
      </Box>
      <Box >
        <Card variant="outlined" sx={{ p: 2, m: 1 }} >
          <Typography gutterBottom variant="h5" sx={{ p: 2 }} component="div">
            Duplicates for Review 
          </Typography>
          <Divider />
           <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="a simple table ">
              <TableHead>
                <TableRow> 
                    { (matchFirstLast || matchFullName) &&
                       <>
                         <TableCell>Firstname</TableCell>
                         <TableCell>Lastname</TableCell>
                       </>
                    }
                   { matchPhone &&
                      <TableCell>Phone</TableCell>
                   }
                   { matchAddress1 &&
                    <TableCell>Address 1</TableCell>
                   }
                   { matchCity &&
                      <TableCell>City</TableCell>
                   }
                   { matchZip &&
                    <TableCell>Zip</TableCell>
                  }
                   <TableCell># of Matching Clients</TableCell>
                </TableRow> 
              </TableHead>
                <TableBody>

            {duplicates.map((duplicate) => 
               <>
               <TableRow
              key={duplicate.id}
              style={{cursor: "pointer"}}
              hover={activeDuplicateId != duplicate.id}
              onClick={() => activeDuplicateId == duplicate.id ? setActiveDuplicatesId(null) : findCorrespondingDuplicates(duplicate.id)}
              sx={{ '&:last-child TableCell, &:last-child th': { border: 0 } }}
            >
                { (matchFirstLast || matchFullName) &&
                  <>
                    <TableCell>{duplicate.firstname}</TableCell>
                    <TableCell>{duplicate.lastname}</TableCell>
                  </>
                }
                { matchPhone &&
                  <TableCell>{formatPhone(duplicate.mobilephone)}</TableCell>
                }
                { matchAddress1 &&
                  <TableCell>{duplicate.address_1}</TableCell>
                }
                { matchCity &&
                  <TableCell>{duplicate.city}</TableCell>
                }
                { matchZip && 
                  <TableCell>{duplicate.zip}</TableCell>
                }
                <TableCell>{duplicate.count}</TableCell>
              </TableRow>
              {(activeDuplicateId == duplicate.id) &&
                <>
                <GrayTableRow> 
                  <TableCell colspan={1 + ((matchFirstLast || matchFullName) ? 2 : 0) + [matchPhone, matchZip, matchAddress1, matchCity].filter((x) => x).length} >
                    <Box sx={{ ml: 10, mb: 1, textAlign: "left", }}>
                      <h2>Review and Confirm Duplicates to Merge</h2>
                    </Box>
                       <Box sx={{ml: 10 }}> 
                       <TableContainer component={Paper}>
                        <Table size='small'  sx={{ minWidth: 650 }} aria-label="table">
                          <TableHead>
                            <TableRow> 
                               <TableCell>Created</TableCell>
                               <TableCell>Client ID</TableCell>
                               <TableCell>Status</TableCell>
                               <TableCell>Firstname</TableCell>
                               <TableCell>Middle</TableCell>
                               <TableCell>Lastname</TableCell>
                               <TableCell>Phone</TableCell>
                               <TableCell>Address 1</TableCell>
                               <TableCell>City</TableCell>
                               <TableCell>Zip</TableCell>
                               <TableCell>Should Merge</TableCell>
                               <TableCell>Master</TableCell>
                               <TableCell>View in new Tab</TableCell>
                            </TableRow> 
                          </TableHead>
                          <TableBody>
                             {activeDuplicates.map((innerDuplicate) => 
                             <TableRow
                            key={innerDuplicate.id}
                            sx={{ '&:last-child TableCell, &:last-child th': { border: 0 } }}
                          >
                              <TableCell>{(new Date(innerDuplicate.created_at)).toLocaleString().split(",")[0]}</TableCell>
                              <TableCell>{innerDuplicate.id}</TableCell>
                              <TableCell>{formatClientStatus(innerDuplicate.client_state)}</TableCell>
                              <TableCell>{innerDuplicate.firstname}</TableCell>
                              <TableCell>{innerDuplicate.middlename}</TableCell>
                              <TableCell>{innerDuplicate.lastname}</TableCell>
                              <TableCell>{formatPhone(innerDuplicate.mobilephone)}</TableCell>
                              <TableCell>{innerDuplicate.address_1}</TableCell>
                              <TableCell>{innerDuplicate.city}</TableCell>
                              <TableCell>{innerDuplicate.zip}</TableCell>
                              <TableCell>
  
          <FormControlLabel
            label="Merge"
            control={<Checkbox checked={innerDuplicate.merge} onChange={(e) => setShouldMerge(innerDuplicate.id, e.target.checked)} />}
          />
</TableCell>
                              <TableCell>
  
          <FormControlLabel
            label="Is Master"
            control={<Checkbox checked={innerDuplicate.master} onChange={(e) => setMaster(innerDuplicate.id, e.target.checked)} />}
          />
</TableCell>
                              <TableCell><a target="__blank" href={host + '/cms/clients/' + innerDuplicate.id + "?site_id=" + site_id}><Button variant="outlined" endIcon={<LaunchIcon />}>
 View 
</Button></a></TableCell>
                            </TableRow>)}

                          </TableBody>
                        </Table>
                      </TableContainer>
                      { mergeError &&
                        <Alert sx={{ border: 0, borderColor: 'danger', m: 1 }}icon={<CheckIcon fontSize="inherit" />} severity="error">
                          {mergeError} 
                        </Alert>
                      }
                      <Box sx={{ mt: 2}}>
                        <Button 
                          color='default' 
                          sx={{ mr: 1 }}
                          onClick={() => findCorrespondingDuplicates(getNextDuplicateId(activeDuplicateId))}
                          variant={"contained"}>
                            Cancel 
                          </Button>
                        <Button 
                          color='info' 
                          disabled={isLoadingDuplicates}
                          sx={{ mr: 1 }}
                          onClick={() => archiveMerge(duplicate)}
                          variant={"contained"}>
                            Archive  
                          </Button>
                        <Button 
                          color='primary' 
                          disabled={isLoadingDuplicates}
                          onClick={() => merge(duplicate)}
                          variant={"contained"}>
                            {"Merge " + activeDuplicates.filter((dup) => (dup.merge || dup.master)).length  + " Duplicates"} 
                          </Button>
                      </Box>
                  </Box>
                  </TableCell>
                </GrayTableRow>
                </>
              }
              </>)}
        </TableBody>
        </Table>
        </TableContainer>
      </Card>
      </Box>
    </div>
  );
}

export default App;
